<div  class=" flex-center-center flex-direction-column" style="margin: 20px">
  <div class="logo" style="margin-bottom: 10px">
    <a routerLink="/auth/login"><img [src]="logo" width="150px"></a>
  </div>
  <app-template-form title="{{'login' | translate}}" subtitle="{{'credentials' | translate}}" style="width: 800px;max-width: 100%">
    <form [formGroup]="loginForm" (submit)="login()">
      <mat-form-field floatLabel="auto" appearance="fill" class="w100">
        <mat-label translate>{{ 'email' }}</mat-label>
        <input matInput id="email"
          formControlName="email" autocomplete="username">
        <!--                <mat-error *ngIf="loginForm.get('email').invalid">{{ 'email_validation' }}</mat-error>-->
      </mat-form-field>
      <mat-form-field floatLabel="auto" appearance="fill" class="w100">
        <mat-label>{{ 'password' |translate}}</mat-label>
        <input matInput id="password" formControlName="password" autocomplete="current-password"
          [type]="hide ? 'password': 'text'">
        <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
        <!--                <mat-error *ngIf="loginForm.get('password').invalid">{{ 'password' }}</mat-error>-->
      </mat-form-field>

      @if (showOtpField) {
        <mat-form-field floatLabel="auto" appearance="fill" class="w100">
          <mat-label>{{ 'codiceDueFattori' | translate }}</mat-label>
          <input matInput formControlName="otp" autocomplete="one-time-code">
          <button mat-icon-button matSuffix (click)="requestOtp()" type="button">
            <mat-icon>mail_outline</mat-icon>
          </button>
        </mat-form-field>
      }

      <div class="flex-between-center w100">
        <div class="text-color-primary" style="cursor: pointer" routerLink="/auth/recovery">
          {{ 'recovery_password' | translate }}
        </div>
        @if (showOtpField) {
          <button mat-raised-button color="accent" type="button" (click)="requestOtp()">
            {{ 'getCode' | translate }}
          </button>
        }
      </div>

      <div class="spacerh10"></div>

      <button mat-flat-button class="w100" color="primary" type="submit"
        [disabled]="loading||loginForm.invalid">{{ 'login' |translate}}
      </button>
      <div class="spacerh5"></div>
      @if (passkeySupported) {
        <button mat-stroked-button class="w100" color="primary" type="button"
          [disabled]="loading" (click)="loginWithPasskey()">
          <mat-icon>fingerprint</mat-icon>
          {{ 'passkey.login' | translate }}
        </button>
        <div class="spacerh5"></div>
      }
      <!--            <button-->
      <!--                    mat-stroked-button class="w100" color="primary" type="button"-->
      <!--                    routerLink="/auth/signup">{{ 'signup' |translate}}-->
    <!--            </button>-->
  </form>
</app-template-form>
</div>


